import baseAPI from '@/http'

const router = 'api/indicador/indicador'

export const indicadorAPI = {
  create: (indicador) => baseAPI.post(router, indicador),
  update: (indicador) => baseAPI.put(router, indicador),
  delete: (id) => baseAPI.delete(`${router}/${id}`),
  list: () => baseAPI.get(router),
  get: (id) => baseAPI.get(`${router}/${id}`),
  getCabecalhoTabela: (id) => baseAPI.get(`${router}/get-cabecalho-by-indicador-subgrupo/${id}`),
  salvarIndicadoresMunicipio: (indicadores) => baseAPI.put(`${router}/salvar-indicadores-municipio`, indicadores)
}
